export const colors = {
  primary: '#2C469A',
  secondary: '#FFCC29',
  primaryDark: '#344c9a',
  secondaryDark: '#cea72a',
  dark: '#1d1d1f',
  grey: '#6e6e73',
};
